import { render, staticRenderFns } from "./InputComboboxCpt.vue?vue&type=template&id=2fe44fe2&"
import script from "./InputComboboxCpt.vue?vue&type=script&lang=ts&"
export * from "./InputComboboxCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputComboboxCpt.vue?vue&type=style&index=0&id=2fe44fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
